import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const SweeperBulletContainerStyle = styled(Stack)(({ theme }) => ({
  ".bullet-active": {
    background: theme.customColors.backgroundPrimaryCta,
    transition: "all .1s linear",
    width: "1.3125rem"
  },
  ":hover": {
    background: theme.customColors.backgroundPrimaryControlHover,
    borderColor: theme.customColors.borderPrimaryControlHover,

    transition: "all .1s linear"
  },
  alignItems: "center",
  background: theme.customColors.backgroundPrimaryControl,
  border: `1px solid ${theme.customColors.borderPrimaryControl}`,
  borderRadius: "1048575rem",
  display: "flex",
  flexDirection: "row",
  gap: "0.4375rem",
  height: "1.5375rem",
  padding: "0.5rem 0.71875rem"
}));
